var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import ObjectLoader from "../services/cachedObjectLoader";
import SecuredDataApi, { SecuredData } from "../asset/securedDataWithMetaData";
var keyStoreService = require("crypto/keyStore");
var SignedKeysLoader = /** @class */ (function (_super) {
    __extends(SignedKeysLoader, _super);
    function SignedKeysLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SignedKeysLoader;
}(ObjectLoader({
    cacheName: "signedKeys",
    getID: function (_a) {
        var _signature = _a.signedKeys._signature, signKey = _a.signKey;
        return signKey + "-" + _signature;
    },
    download: function () { throw new Error("profile get by id is not implemented"); },
    load: function (_a) {
        var signedKeys = _a.signedKeys, signKey = _a.signKey;
        var securedData = SecuredDataApi.load(undefined, signedKeys, { type: "signedKeys" });
        return securedData.verifyAsync(signKey).then(function () {
            return securedData.metaGet();
        });
    },
    restore: function (signedKeysCache) {
        var signedKeys = new SecuredData(undefined, signedKeysCache, { type: "signedKeys" }, true);
        var friends = signedKeys.metaAttr("friends");
        var crypt = signedKeys.metaAttr("crypt");
        keyStoreService.security.addEncryptionIdentifier(friends);
        keyStoreService.security.addEncryptionIdentifier(crypt);
        return signedKeys;
    }
})));
export { SignedKeysLoader };



//////////////////
// WEBPACK FOOTER
// ./js/users/signedKeys.ts
// module id = null
// module chunks = 